import { render, staticRenderFns } from "./DashboardApproval.vue?vue&type=template&id=60e3d824&"
import script from "./DashboardApproval.vue?vue&type=script&lang=js&"
export * from "./DashboardApproval.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports